module.exports = __webpack_public_path__ + "static/images/idCardExample-3.313e101.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/idCardExample-3.png
// module id = Hah0
// module chunks = 0